import React from 'react';
import PrivateRoute from './PrivateRoute';
import SettingsContainer from 'components/settings/SettingsContainer';
import Profile from 'components/settings/Users/Profile';
import Facilities from 'components/facilities';
import config from 'coeus.config';
import Analytics from 'components/Pages/Analytics';
import Dashboard from 'components/Pages/Dashboard';

const privateRoutes = () => {
    const routes = [
        <PrivateRoute
            key="settings"
            path="/settings"
            component={SettingsContainer}
        />,
        <PrivateRoute key="user-profile" path="/profile" component={Profile} />,
    ];

    if (!config.feature.public_access.enabled) {
        routes.push(
            <PrivateRoute
                key="dashboard"
                path="/dashboard"
                exact
                component={Dashboard}
            />,
            <PrivateRoute
                key="page"
                path="/pages/:id"
                exact
                component={Analytics}
            />
        );
    }

    if (config.feature.upload_manager.enabled) {
        routes.push(
            <PrivateRoute
                key="facilities"
                path="/facilities"
                component={Facilities}
            />
        );
    }
    return routes;
};

export default privateRoutes;
